
const messages = {
    en: {
        menu: {
            userdashboard: 'Users Dashboard',
            customization: 'Customization',
            administration: 'Administration',
            products: 'Products',
            sales: 'Sales',
            purchases: 'Purchases',
            ordenesCompra: 'Purchase orders',
            statistics: 'Statistics',
            adminConfig: 'Configuration'
        }
    },
    es: {
        menu: {
            userdashboard: 'Tablero de Usuarios',
            customization: 'Personalización',
            administration: 'Administración',
            products: 'Productos',
            sales: 'Ventas',
            purchases: 'Compras',
            ordenesCompra: 'Órdenes de compra',
            statistics: 'Estadísticas',
            adminConfig: 'Administración'
        }
    },
    pt: {
        menu: {
            userdashboard: 'Painel de controle',
            customization: 'Costumização',
            administration: 'administração',
            products: 'Produtos',
            sales: 'Vendas',
            purchases: 'Compras',
            ordenesCompra: 'Ordens de compra',
            statistics: 'Estatísticas',
            adminConfig: 'Administração'
        }
    }
}

export default messages
